/* eslint-disable @typescript-eslint/no-explicit-any */
import { getClient } from 'azure-devops-extension-api';
import { WorkItemTrackingRestClient, FieldType } from 'azure-devops-extension-api/WorkItemTracking';

export const getFieldType = (value: number) => FieldType[value];

export async function getWorkItemTypes(projectId: string) {
	const client = getClient(WorkItemTrackingRestClient);
	return await client.getWorkItemTypes(projectId);
}